export default __webpack_public_path__ + "static/media/hepsiorada.456d191d.jpg";